import React from 'react';
import IIconInput from './IIconInput';
import Input from '@appComponents/Input/Input';
import { classNames } from '@features/utils/reactFunctions';

import * as style from './IconInputStyle.module.scss'

const IconInput: React.FunctionComponent<IIconInput> = (props: IIconInput) => {
  return (
    <div className={classNames(style.iconInput, props.label && style.labeled)}>
      <span className={style.icon}>{props.icon}</span>
      <Input {...props} />
    </div>
  );
};

export default React.memo(IconInput);
